var app = angular.module('leonardo');

var BaseRestService = function(Restangular, $q, $rootScope, $filter, CacheService) {
  var createService = function(name, fn) {
    var canceler = $q.defer();

    var service = fn ? Restangular.withConfig(fn).service(name) : Restangular.service(name);

    service.collection = [];
    service.initialized = false;

    service.getCollection = function () {
      // If collection is empty, try to get from cache
      if (!service.collection || service.collection.length === 0) {
        var cachedData = CacheService.get(name);
        if (cachedData) {
          var items = cachedData.results ? cachedData.results : cachedData;
          if (items && items.length > 0) {
            service.collection = items;
            service.initialized = true;
          }
        }
      }
      return service.collection || [];
    };

    service.setCollection = function (list) {
      service.collection = list;
    };

    service.updateCollection = function (element, remove) {
      var index = -1;
      if (service.initialized) {
        angular.forEach(service.collection, function (value, key) {
          if (element.id === value.id) {
            index = key;
          }
        });
        if (index < 0 && !remove) {
          service.collection.push(element);
        }
        else if(remove) {
          service.collection.splice(index, 1);
        }
        else {
          service.collection[index] = element;
        }
        service.setCollection($filter('orderBy')(service.collection, 'name'));
      }
      else {
        service.getAll({essential:true}, false, true).then(function () {
          angular.forEach(service.collection, function (value, key) {
            if (element.id === value.id) {
              index = key;
            }
          });
          if (index < 0 && !remove) {
            service.collection.push(element);
          }
          else if(remove) {
            service.collection.splice(index, 1);
          }
          else {
            service.collection[index] = element;
          }
          service.collection = $filter('orderBy')(service.collection, 'name');
        });
      }
    };

    service.getAllRecursive = function(options, method) {
      options = options || {};
      method = method || 'getList';

      var defer = $q.defer();
      var all = [];
      var recursive = function (page) {
        var opt = angular.copy(options);
        opt['page'] = page;
        service[method](opt).then(function (results) {
          // Al must be a valid reference, so we cannot _.union
          angular.forEach(results, function(result) {
            all.push(result);
          });
          if (!results.meta){
            service.setCollection(all);
            service.initialized = true;
            defer.resolve(all);
            return;
          }
          if (all.length === results.meta.count) {
            all.meta = results.meta;
            service.setCollection(all);
            service.initialized = true;
            defer.resolve(all);
            return;
          }
          recursive(page + 1);
        }, function(error){
          service.setCollection(all);
          service.initialized = true;
          defer.resolve(all);
        });
      };
      recursive(1);

      defer.promise.$object = all;
      return defer.promise;
    };

    service.getAll = function(options, noUpdated, noCancel) {
      if (!noCancel) {
        canceler.resolve();
        canceler = $q.defer();
      }
      options = options || {};
      options['disable_pagination'] = true;
      var defer = $q.defer();
      var all = [];
      var params = !noCancel ? {timeout: canceler.promise} : {};
      service.withHttpConfig(params)['getList'](options).then(function (results) {
        // Al must be a valid reference, so we cannot _.union
        angular.forEach(results, function(result) {
          all.push(result);
        });
        all.meta = results.meta;
        if (!noUpdated) {
          service.setCollection(all);
        }
        service.initialized = true;
        defer.resolve(all);
      }, function(error){
        if (!noUpdated) {
          service.setCollection(all);
        }
        service.initialized = true;
        defer.reject(error);
      });
      defer.promise.$object = all;
      return defer.promise;
    };

    service.getlist = function(options, noCancel) {
      if (!noCancel) {
        canceler.resolve();
        canceler = $q.defer();
      }
      options = options || {};
      var defer = $q.defer();
      var all = [];
      var params = !noCancel ? { timeout: canceler.promise } : {};
      service.withHttpConfig(params)['getList'](options).then(function(results) {
        angular.forEach(results, function(result) {
          all.push(result);
        });
        all.meta = results.meta;
        defer.resolve(all);
      }, function(error){
        defer.reject(error);
      });
      defer.promise.$object = all;
      return defer.promise;
    };
 
    // Fetch a single record by options
    service.get = function(options, noCancel) {
      if (!noCancel) {
        canceler.resolve();
        canceler = $q.defer();
      }
      options = options || {};
      var defer = $q.defer();
      var data = {};
      var params = !noCancel ? { timeout: canceler.promise } : {};
      service.withHttpConfig(params)['get'](options).then(function(result) {
        data = result;
        defer.resolve(data);
      }, function(error) {
        defer.reject(error);
      });
      defer.promise.$object = data;
      return defer.promise;
    };
 
    // Create a new record
    service.post = function(options, noCancel) {
      if (!noCancel) {
        canceler.resolve();
        canceler = $q.defer();
      }
      options = options || {};
      var defer = $q.defer();
      var data = {};
      var params = !noCancel ? { timeout: canceler.promise } : {};
      service.withHttpConfig(params)['post'](options).then(function(result) {
        data = result;
        defer.resolve(data);
      }, function(error) {
        defer.reject(error);
      });
      defer.promise.$object = data;
      return defer.promise;
    };
 
    // Delete a record by ID
    service.delete = function(id, noCancel) {      
      if (!noCancel) {
        canceler.resolve();
        canceler = $q.defer();
      }
      var defer = $q.defer();
      var params = !noCancel ? { timeout: canceler.promise } : {};
    
      // Call the delete operation directly using the `id` passed
      service.withHttpConfig(params).one(id).remove().then(function(result) {
        defer.resolve(result);
      }, function(error) {
        defer.reject(error);
      });
    
      return defer.promise;
    };

    return service;
  };

  return function(name, fn) {
    var serviceRest = createService(name, fn);

    $rootScope.$on('changeHeaders', function(){
      serviceRest = createService(name, fn);
    });

    $rootScope.$on('white-label:update-theme', function(){
      serviceRest = createService(name, fn);
    });

    return serviceRest;
  };
};

app.factory('BaseRestService', ['Restangular', '$q', '$rootScope', '$filter', 'CacheService', BaseRestService]);
